import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { ContactSupportLink } from "components/support";
import { Icon } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const EmptyFolderMessage: React.FC = () => {
  return (
    <Grid item container direction="row" className={cssExports.emptyMessageContainer} columnGap={1} wrap="nowrap">
      <Grid item>
        <Icon className={cssExports.emptyMessageIcon} icon={IconDefinitionConstants.WInfo} />
      </Grid>
      <Grid
        item
        container
        className={cssExports.emptyMessageText}
        direction="column"
        alignItems="start"
        columnGap={0.25}
      >
        <Grid item>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.SharedFolderEmptyMessage)}
        </Grid>
        <Grid item>
          <ContactSupportLink />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EmptyFolderMessage;
